import { useState } from "react";
import { client } from "../../sanityClient";
import "./NewGrainForm.css";

export default function NewGrainForm({ onClose, onGrainCreated, showToast }) {
    const [grainName, setGrainName] = useState("");
    const [loading, setLoading] = useState(false);

    const generateTimestampID = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const ms = now.getMilliseconds().toString().padStart(3, "0");
        return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${ms}`;
    };

    const handleCreateGrain = async (e) => {
        e.preventDefault();
        if (!grainName) {
            showToast("error", "Please enter a grain name");
            return;
        }

        setLoading(true);
        try {
            // Check if grain with same name already exists (case-insensitive)
            const existingGrains = await client.fetch(
                `*[_type == "grain" && lower(grainName) == $name]`,
                { name: grainName.toLowerCase() }
            );
            console.log(existingGrains);

            if (existingGrains.length > 0) {
                console.log("Grain with same name already exists");
                showToast("error", "A grain with this name already exists");
                setLoading(false);
                return;
            }

            const grainID = generateTimestampID();
            const doc = {
                _type: "grain",
                grainID,
                grainName: grainName,
            };

            const createdGrain = await client.create(doc);
            setGrainName("");
            onGrainCreated(createdGrain);
            onClose();
            showToast("success", `Grain added! ID: ${grainID}`);
        } catch (err) {
            console.error("Error creating grain:", err);
            showToast("error", "Failed to add grain");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="new-grain-modal" onClick={onClose}>
            <div className="new-grain-content" onClick={(e) => e.stopPropagation()}>
                <div className="new-grain-header">
                    <h5 className="new-grain-title">Add New Grain</h5>
                    <button className="new-grain-close" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="new-grain-body">
                    <form onSubmit={handleCreateGrain}>
                        <div className="new-grain-group">
                            <label className="new-grain-label">
                                Grain Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="new-grain-input"
                                placeholder="Enter grain name"
                                value={grainName}
                                onChange={(e) => setGrainName(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="new-grain-btn" disabled={loading}>
                            {loading ? "Saving..." : "Save Grain"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
